import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import updateIconImg from "../../Assets/updateIconImg.png";
import transfer_approved from "../../Assets/Transfer_approved.png";
import transfer from "../../Assets/Transfer.png";
import * as masterSelectors from "../../Store/ANMDetails/ANMDetailsSelectors.jsx";
import { ANMTransferPopup } from "../ANMDetails/ANMTransferPopup.jsx";
import { useLanguage } from "../ChangeLanguage/LanguageProvider.jsx";
import { headerStyle, bodyStyle } from "../../Shared/Utils/tableColumns.jsx";
import { fetchANMDetails } from "../../Store/ANMDetails/ANMDetailsActions.jsx";
import ANMUpdateform from "../ANMDetails/ANMUpdateform.jsx";
import "../ANMDetails/ANMTransferPopup.scss";

export const statusBodyTemplate = (rowData) => {
  const defaultColor = "#FFA944";
  const statusColors = {
    Approved: "#209860",
    Rejected: "#F06373",
  };
  const color = statusColors[rowData.status] || defaultColor;
  return (
    <p
      style={{
        color: color,
        fontWeight: 600,
      }}
    >
      {rowData.status}
    </p>
  );
};
const AFDetailsView = () => {
  const { t } = useTranslation("anmdetailsPhc");
  const dispatch = useDispatch();
  const masterData = useSelector(masterSelectors.getAFDetails);
  const [loginDetailsVisible, setLoginDetailsVisible] = useState(false);
  const [data, setData] = useState([]);
  const [formMode, setFormMode] = useState("Add");
  const [selectedItems, setSelectedItems] = useState([]);
  const { selectedLanguageId } = useLanguage();
  const rowsPerPageOptions = [5, 10, 20, 50];
  const defaultRowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const onPageChange = (event) => {
    setCurrentPage(event.first / event.rows);
    setRowsPerPage(event.rows);
  };
  const selectedType = "AF";
  const [visible, setVisible] = useState(false);
  const getUniqueStatusValues = (data) => {
    if (!data) {
      return [];
    }
    return [...new Set(data.map((item) => item.status))];
  };
  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={getUniqueStatusValues(masterData)}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={t("Select")}
        showClear
        className="cockpit-filter-dropdown"
      />
    );
  };
  const fetchData = useCallback(() => {
    dispatch(fetchANMDetails(selectedLanguageId, selectedType));
  }, [dispatch, selectedLanguageId, selectedType]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    if (masterData) {
      setData(masterData);
    }
  }, [masterData]);
  const Update = () => {
    if (selectedItems.length === 1) {
      setFormMode("Update");
      setVisible(true);
    } else {
      setVisible(false);
    }
  };
  const renderImage = useCallback(
    (rowData) => {
      const imagePath =
        rowData.status === "Approved" ? transfer_approved : transfer;
      const handleImageClick = () => {
        setLoginDetailsVisible(true);
        setSelectedItems([rowData]);
      };
      const handlePopupClose = () => {
        setLoginDetailsVisible(false);
      };
      return (
        <>
          <img
            src={imagePath}
            alt={rowData.actions}
            onClick={handleImageClick}
          />
          <ANMTransferPopup
          visible={loginDetailsVisible}
          onClose={handlePopupClose}
          selectedItems={selectedItems}
          languageId={selectedLanguageId}
          mode={formMode}
          setVisible={setVisible}
        />
        </>
      );
    },
    [
      loginDetailsVisible,
      selectedItems,
      selectedLanguageId,
      formMode,
      setLoginDetailsVisible,
      setSelectedItems,
    ]
  );
  return (
    <>
      <div className="masterScreen">
        <div className="grid flex justify-content-end mb-2">
          <div className=" md:col-6 col-div"></div>
          <div className="sm:col-12 md:col-6 button_section">
            <div className="grid align-items-center justify-content-end">
              <div className="flex sm:col-12 sm:text-center justify-content-end align-items-center md:col pr-0">
                <Button
                  data-testid="update-user-data"
                  className="master-updateBtn"
                  label={t("Update")}
                  severity="info"
                  onClick={Update}
                  icon={<img src={updateIconImg} alt={t("Update icon")} />}
                  outlined
                  disabled={selectedItems.length !== 1}
                  tooltip={t("Update ANM data")}
                  tooltipOptions={{ position: "bottom", event: "both" }}
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          className="table-viewports custom-tooltip"
          resizableColumns
          size="small"
          selectionMode={"checkbox"}
          value={data}
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          selection={selectedItems}
          onSelectionChange={(e) => setSelectedItems(e.value)}
          scrollable
          scrollHeight="510px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={rowsPerPage}
          first={currentPage * rowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          onPage={(event) => onPageChange(event)}
          totalRecords={data.length}
        >
          <Column selectionMode="multiple" header={t("Select")} frozen={true} />

          <Column
            field="ashaanmid"
            header={t("AF ID")}
            filter
            frozen={true}
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
          />
          <Column
            field="firstname"
            header={t("FirstName")}
            filter
            filterPlaceholder={t("Search")}
            frozen={true}
            showFilterMenu={false}
          />
          <Column
            field="lastname"
            header={t("LastName")}
            filter
            filterPlaceholder={t("Search")}
            frozen={true}
            showFilterMenu={false}
          />
          <Column
            field="status"
            header={t("Status")}
            body={statusBodyTemplate}
            filter
            showFilterMenu={false}
            frozen={true}
            filterElement={statusRowFilterTemplate}
            headerStyle={headerStyle}
            bodyStyle={{ borderRight: "3px solid #d9d9d9" }}
          />
          <Column
            field="mobilenumber"
            header={t("ContactNo")}
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
          />
          <Column
            field="subcenternames"
            header={t("SubcentersAssigned")}
            filter
            filterPlaceholder={t("Search")}
            showFilterMenu={false}
            body={(rowData) => rowData.subcenternames.join(", ")}
          />

          <Column
            field="bf_count"
            header={t("NoofBFs")}
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
          />
          <Column
            field="asha_count"
            header={t("NoofASHAs")}
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
          />
          <Column
            field="approvedBy"
            header={t("Approved")}
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
          />
          <Column
            header={t("ApprovedDate&Time")}
            field="approvedDate"
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
          />
          <Column
            header={t("Actions")}
            body={renderImage}
            frozen={true}
            alignFrozen="right"
            headerStyle={bodyStyle}
            bodyStyle={bodyStyle}
          />
        </DataTable>
        <p>
          {data.length} {t("Totalrecord")}
        </p>
      </div>
      <ANMUpdateform
        selectedItems={selectedItems}
        visible={visible}
        setVisible={setVisible}
        mode={formMode}
        type="AF"
      />
    </>
  );
};

export default AFDetailsView;
